import { Spin, Tag, Tooltip } from 'antd';
import { FC, memo } from 'react';
import { EmojiDizzyFill, HeartFill } from 'react-bootstrap-icons';

import { Domain, DomainHealthStatus } from '@/modules/Domains';

interface Props {
  status: Domain['healthStatus'];
  big?: boolean;
  simple?: boolean;
}

export const DomainHealthTag: FC<Props> = memo(({ status, big = false, simple = false }) => {
  const text = simple ? '' : <>Доступність:&nbsp;</>;

  if (status === DomainHealthStatus.Working) {
    return (
      <Tooltip title="працює">
        <Tag color="success" bordered={ !simple } style={{ paddingBlock: simple ? 2.5 : 1 }}>
          { text }
          <HeartFill size={ big ? 16 : 12 }/>
        </Tag>
      </Tooltip>
    );
  }

  if (status === DomainHealthStatus.NotWorking) {
    return (
      <Tooltip title="не працює">
        <Tag color="error" bordered={ !simple } style={{ paddingBlock: simple ? 2.5 : 1 }}>
          { text }
          <EmojiDizzyFill size={ big ? 16 : 12 }/>
        </Tag>
      </Tooltip>
    );
  }

  if (status === DomainHealthStatus.Checking) {
    return (
      <Tooltip title="перевірка">
        <Tag color="geekblue" bordered={ !simple } style={{ paddingBlock: simple ? 2 : 0 }}>
          { text }
          <Spin size="small" spinning/>
        </Tag>
      </Tooltip>
    );
  }
});
